<template>
  <Wrapper
    ref="wrapper"
    type-list="following"
    :item-source="fetchFollowings"
    :dummy-props="{
      headerText: $t(
        '_web_account-list_dummy_following',
        'You are not following anyone at the moment'
      ),
      text: $t(
        '_web_account-list_dummy_following_subheader_teams',
        'Start following other players, teams and organisers to keep up to date'
      ),
    }"
  >
    <ListItemAccount
      v-if="!user.isHidden"
      :key="user.login"
      slot-scope="{ user }"
      v-bind="{
        type: user.type,
        avatar: user.avatar,
        name: $filters.displayName(user),
        accountId: user.login,
        approved: user.approved,
        vanityId: user.vanityId || user.vanity_id,
      }"
      class="mb-3 py-2 pl-5 pr-5"
    >
      <div
        v-if="account._canEdit && myAccountId !== user.login"
        slot="action"
        class="d-flex align-items-center"
      >
        <FollowBtn
          v-if="myAccountId !== user.login"
          :model="createAccountModel(user)"
          follow-class=""
          class="h-mr-3"
          @toggleFollow="isFollow => toggleFollow(isFollow, user)"
        />
        <AppIcon
          name="dots"
          class="cursor-pointer px-3 py-4 following-smalls "
          :class="{ disabled: !canAddToFriend(user) }"
          :fill="$scss.heraMuted"
          :hover-fill="$scss.hoverColor"
          @click.stop="event => dotsClickHandler(event, user)"
        />
      </div>
    </ListItemAccount>
  </Wrapper>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import ListItemAccount from '@/components/common/ListItemAccount';
import Wrapper from '../ListWrapper';
import FollowBtn from '@/components/common/FollowBtn';
import AccountModel from '@/models/Account';
import AppIcon from '@/components/atoms/Icon';
import { PROFILE } from '@/constants/accounts';
import { friendRequest } from '@/mixins/accountActions/profile';

export default {
  name: 'AccountFollowings',
  components: {
    Wrapper,
    ListItemAccount,
    FollowBtn,
    AppIcon,
  },
  mixins: [friendRequest],
  computed: {
    ...mapState('current', ['account']),
    ...mapState('my', { myAccount: 'account', myAccountId: 'accountId' }),
    ...mapGetters(['hasAccessByPermission']),
  },
  methods: {
    ...mapActions(['fetchFollowings']),
    canAddToFriend(user) {
      return this.hasAccessByPermission('addToFriend') && user.type === PROFILE;
    },
    toggleFollow(isFollow, user) {
      this.$set(user['social_metadata'], 'is_follow', isFollow);
      if (this.myAccount === this.account) {
        this.$set(user, 'isHidden', true);
        this.$refs.wrapper.pingScroll();
        this.myAccount.updateCounters({
          following: isFollow ? +1 : -1,
        });
      }
    },
    toggleFriends(user) {
      this.friendRequestProfileAction({
        socials: this.getAccountSocial(user),
        accountId: user.login,
        accountType: user.type,
      })
        .then(
          ({
            isFriend,
            isFriendRequested,
            isFriendRequestedBy,
            isFollow,
            addedToFriend,
            removedToFriend,
          } = {}) => {
            this.$refs.wrapper.updateUser({
              ...user,
              social_metadata: {
                ...user.social_metadata,
                is_follow: isFollow,
                is_friend: isFriend,
                is_friend_requested: isFriendRequested,
                is_friend_requested_by: isFriendRequestedBy,
              },
            });
            this.myAccount.updateCounters({
              friends: addedToFriend ? +1 : removedToFriend ? -1 : 0,
            });
          }
        )
        .finally(() => {
          this.popoverPositionTarget = null;
        });
    },

    dotsClickHandler(event, user) {
      this.items = [
        {
          label: this.friendRequestProfileText({
            socials: this.getAccountSocial(user),
          }),
          action: this.toggleFriends.bind(this, user),
          loading: this.waitingFriendRequest,
        },
        // {
        //   label: this.reportProfileText(),
        //   action: () => this.reportProfileAction(),
        //   loading: this.waitingReportRequest,
        // },
      ];
      this.popoverPositionTarget = event.target;
    },
    createAccountModel(user) {
      return new AccountModel(user.type, user.login).update(user);
    },
  },
};
</script>
<style lang="scss">
@media (max-width: 767px) {
  .following-smalls {
    display: none;
  }
}
</style>
